import {
  COMPARE_BY_OPTION,
  type CompareByDimension,
  type CompareByOption,
} from "../../compare-by"
import { isReportViewMode, REPORT_VIEW_MODE } from "./reportViewMode"

export type SharedReportCompareByOption =
  | (typeof COMPARE_BY_OPTION)[keyof typeof COMPARE_BY_OPTION]
  | Exclude<CompareByDimension, "metadata" | "custom" | "tag">

export function clampCompareByToPageSupported(
  value: CompareByOption | null | undefined,
): SharedReportCompareByOption {
  switch (value) {
    case COMPARE_BY_OPTION.NONE:
    case "run":
    case "agent":
    case "mutation":
    case "persona":
    case "test_case":
      return value
    // "tag" falls through with the unsupported bucket: the shared-run
    // metadata contract omits tags and the shared UI has no
    // OrganizationTag color source, so a saved tag value would collapse
    // every row into Untagged and drop tag colors. Re-expose once the
    // public contract exposes tags.
    case "tag":
    case undefined:
    case null:
    case "metadata":
    case "custom":
    default:
      return COMPARE_BY_OPTION.NONE
  }
}

export function normalizeSharedReportCompareByConfig(config: {
  compareBy: CompareByOption
  metadataKey: string | null
  viewMode: string
}) {
  const compareBy = clampCompareByToPageSupported(config.compareBy)
  const normalizedViewMode =
    typeof config.viewMode === "string" && isReportViewMode(config.viewMode)
      ? config.viewMode
      : REPORT_VIEW_MODE.ROWS

  return {
    compareBy,
    metadataKey: null,
    viewMode:
      compareBy === COMPARE_BY_OPTION.NONE
        ? REPORT_VIEW_MODE.ROWS
        : normalizedViewMode,
  }
}
